import * as React from "react";
import "../../style/App.css";
import "../../style/userSearch.css";

import translate from "../../translations/i18n";
import myConfig from "../../firebase/config.json";

import UserList from "../searchUser/UserList";
import { duplicateSearch, usernameSearch } from "../../functions/searchApis";

export interface Props {
  auth?: any;
}

interface State {
  searchedValue: string;
  userList: any;
}

class SearchUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      userList: null,
      searchedValue: "",
    };
  }

  async getUsers(searchedValue: string) {
    const searchedUsers = await usernameSearch(searchedValue);
    if (searchedUsers) {
      this.setState({ userList: searchedUsers });
    } else {
      this.setState({ userList: null });
    }
  }

  handleInputChange = (e) => {
    const searchedValue = e.target.value;
    this.setState({ searchedValue });

    if (String(e.target.value).length > 2) {
      this.getUsers(searchedValue);
    } else {
      this.setState({ userList: null });
    }
  };
  render() {
    return (
      <div className="USER_SEARCH_CONT">
        <div className="USERNAME_SEARCH">
          <input
            type="text"
            value={this.state.searchedValue}
            onChange={this.handleInputChange}
            placeholder={translate("USER_SEARCH_FORM")}
          />
        </div>
        <div>
          <UserList users={this.state.userList} />
        </div>
      </div>
    );
  }
}

export default SearchUser;



// WEBPACK FOOTER //
// ./src/components/screens/searchUser.tsx